import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import moment from "moment";
import {BlueButton, GreenButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    emergencyResponseTesting,
    emergencyResponseTestingRevision,
    deleteEmergencyResponseTesting,
    saveOrUpdateEmergencyResponseTesting,
    addEmergencyResponseTestingRevision,
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import CommonRevisionModal from "../common/CommonRevisionModal";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: 'Identifier',
        id: 'displayId',
        type: "text",
    },
    {
        name: 'Company Name',
        id: 'companyName',
        type: "text",
    },
    {
        name: 'Testing Date',
        id: 'displayTestingDate',
        type: "text",
    },
    {
        name: 'Address where the testing is occurring',
        id: 'address',
        type: "text",
    },
    {
        name: 'Staff on duty',
        id: 'staffOnDuty',
        type: "text",
    },
    {
        name: 'Exercise scenario',
        id: 'exerciseScenario',
        type: "text",
    },
];

class EmergencyResponseTesting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            emergencyResponseTesting: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            displayId: "",
            testingDate: null,
            companyName: "",
            address: "",
            staffOnDuty: "",
            exerciseScenario: "",
            wereAllAlerted: "",
            wereAllAlertedComments: "",
            wasAlarmActivated: "",
            wasAlarmActivatedComments: "",
            wasEmergencyCalled: "",
            wasEmergencyCalledComments: "",
            didOccupantsKnowAssemblyPoint: "",
            didOccupantsKnowAssemblyPointComments: "",
            wasBuildingSearched: "",
            wasBuildingSearchedComments: "",
            didAnyoneRefuseToLeave: "",
            didAnyoneRefuseToLeaveComments: "",
            wereAllPeopleAccounted: "",
            wereAllPeopleAccountedComments: "",
            didAnyoneEnterBeforeClear: "",
            didAnyoneEnterBeforeClearComments: "",
            wereEmergencyServiceLiaised: "",
            wereEmergencyServiceLiaisedComments: "",
            notes: "",
        };
        this.loadEmergencyResponseTesting = this.loadEmergencyResponseTesting.bind(this);
        this.loadEmergencyResponseTestingRevision = this.loadEmergencyResponseTestingRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    onDateChange(event, date) {
        this.setState({
            ...this.state, testingDate: moment(date, "DD/MM/YYYY"),
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadEmergencyResponseTesting();
        this.loadEmergencyResponseTestingRevision();
    }

    addRevision(request) {
        addEmergencyResponseTestingRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    loadEmergencyResponseTestingRevision() {
        emergencyResponseTestingRevision()
            .then(response => {
                console.log('emergency testing response revision', response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadEmergencyResponseTesting() {
        emergencyResponseTesting()
            .then(response => {
                console.log('emergencyResponseTestingResponse', response);
                this.setState({
                    emergencyResponseTesting: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(row) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: row.id,
            header: `${row.displayId}`,
            companyName: row.companyName,
            testingDate: row.testingDate,
            address: row.address,
            staffOnDuty: row.staffOnDuty,
            exerciseScenario: row.exerciseScenario,
            wereAllAlerted: row.wereAllAlerted,
            wereAllAlertedComments: row.wereAllAlertedComments,
            wasAlarmActivated: row.wasAlarmActivated,
            wasAlarmActivatedComments: row.wasAlarmActivatedComments,
            wasEmergencyCalled: row.wasEmergencyCalled,
            wasEmergencyCalledComments: row.wasEmergencyCalledComments,
            didOccupantsKnowAssemblyPoint: row.didOccupantsKnowAssemblyPoint,
            didOccupantsKnowAssemblyPointComments: row.didOccupantsKnowAssemblyPointComments,
            wasBuildingSearched: row.wasBuildingSearched,
            wasBuildingSearchedComments: row.wasBuildingSearchedComments,
            didAnyoneRefuseToLeave: row.didAnyoneRefuseToLeave,
            didAnyoneRefuseToLeaveComments: row.didAnyoneRefuseToLeaveComments,
            wereAllPeopleAccounted: row.wereAllPeopleAccounted,
            wereAllPeopleAccountedComments: row.wereAllPeopleAccountedComments,
            didAnyoneEnterBeforeClear: row.didAnyoneEnterBeforeClear,
            didAnyoneEnterBeforeClearComments: row.didAnyoneEnterBeforeClearComments,
            wereEmergencyServiceLiaised: row.wereEmergencyServiceLiaised,
            wereEmergencyServiceLiaisedComments: row.wereEmergencyServiceLiaisedComments,
            notes: row.notes,
        });
    }

    handleAddRow() {
        this.setState({
            id: null,
            isEditing: true,
            isLoading: false,
            isNew: true,
            testingDate: null,
            showTime: null,
            displayId: "",
            companyName: "",
            address: "",
            staffOnDuty: "",
            exerciseScenario: "",
            wereAllAlerted: "",
            wereAllAlertedComments: "",
            wasAlarmActivated: "",
            wasAlarmActivatedComments: "",
            wasEmergencyCalled: "",
            wasEmergencyCalledComments: "",
            didOccupantsKnowAssemblyPoint: "",
            didOccupantsKnowAssemblyPointComments: "",
            wasBuildingSearched: "",
            wasBuildingSearchedComments: "",
            didAnyoneRefuseToLeave: "",
            didAnyoneRefuseToLeaveComments: "",
            wereAllPeopleAccounted: "",
            wereAllPeopleAccountedComments: "",
            didAnyoneEnterBeforeClear: "",
            didAnyoneEnterBeforeClearComments: "",
            wereEmergencyServiceLiaised: "",
            wereEmergencyServiceLiaisedComments: "",
            notes: "",
            header: "New Record",
        })
    }

    reset() {
        this.setState({
            id: null,
            isEditing: false,
            isLoading: true,
            isNew: true,
            testingDate: null,
            showTime: null,
            displayId: "",
            companyName: "",
            address: "",
            staffOnDuty: "",
            exerciseScenario: "",
            wereAllAlerted: "",
            wereAllAlertedComments: "",
            wasAlarmActivated: "",
            wasAlarmActivatedComments: "",
            wasEmergencyCalled: "",
            wasEmergencyCalledComments: "",
            didOccupantsKnowAssemblyPoint: "",
            didOccupantsKnowAssemblyPointComments: "",
            wasBuildingSearched: "",
            wasBuildingSearchedComments: "",
            didAnyoneRefuseToLeave: "",
            didAnyoneRefuseToLeaveComments: "",
            wereAllPeopleAccounted: "",
            wereAllPeopleAccountedComments: "",
            didAnyoneEnterBeforeClear: "",
            didAnyoneEnterBeforeClearComments: "",
            wereEmergencyServiceLiaised: "",
            wereEmergencyServiceLiaisedComments: "",
            notes: "",
            header: "New Record",
        });
        this.loadEmergencyResponseTesting();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteEmergencyResponseTesting(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success('Success', 'The Emergency Response Testing record has been removed.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdateEmergencyResponseTesting(this.state)
        .then((updatedRecord) => {
            NotificationManager.success('Success', 'The Management Emergency Responce Testing record has been updated.', 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                EMERGENCY RESPONSE TESTING
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor}
                                    >
                                        ADD
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                        <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                            :
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={
                                    <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                                }
                            />
                    )}
                    <CardContent>
                        {(!state.isEditing ?
                                <div>
                                    {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/emergency-response-testing/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                                    <TableComponent
                                        tableKey="emergencyResponseTestingTable"
                                        data={state.emergencyResponseTesting}
                                        columns={columns}
                                        handleSubmit={this.handleSubmit}
                                        handleAddRow={this.handleAddRow}
                                        handleRowDel={this.onDelete}
                                        handleRowEdit={this.onEdit}
                                        allowAdd={isRevision && !isAuditor ? 'show' : 'disable'}
                                        pagination={true}
                                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                    />
                                </div>
                                :
                                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="companyName"
                                            name="companyName"
                                            value={state.companyName}
                                            label="Company Name"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px" }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="testingDate"
                                                label="Testing Date"
                                                name="testingDate"
                                                value={state.testingDate}
                                                onChange={ this.onDateChange }
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: "300px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="address"
                                            name="address"
                                            value={state.address}
                                            label="Address where the testing is occurring"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="staffOnDuty"
                                            name="staffOnDuty"
                                            value={state.staffOnDuty}
                                            label="Staff on duty /position /role during exercise"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="exerciseScenario"
                                            name="exerciseScenario"
                                            value={state.exerciseScenario}
                                            label="Exercise scenario i.e. emergency evacuation drill"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wereAllAlerted-label">When the emergency drill commenced were all occupants alerted? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wereAllAlerted-label"
                                                id="wereAllAlerted-id"
                                                value={this.state.wereAllAlerted }
                                                name="wereAllAlerted"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wereAllAlertedComments"
                                            name="wereAllAlertedComments"
                                            value={state.wereAllAlertedComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wasAlarmActivated-label">Was the alarm activated? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wasAlarmActivated-label"
                                                id="wasAlarmActivated-id"
                                                value={this.state.wasAlarmActivated }
                                                name="wasAlarmActivated"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wasAlarmActivatedComments"
                                            name="wasAlarmActivatedComments"
                                            value={state.wasAlarmActivatedComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wasEmergencyCalled-label">Was emergency services called promptly? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wasEmergencyCalled-label"
                                                id="wasEmergencyCalled-id"
                                                value={this.state.wasEmergencyCalled }
                                                name="wasEmergencyCalled"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wasEmergencyCalledComments"
                                            name="wasEmergencyCalledComments"
                                            value={state.wasEmergencyCalledComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="didOccupantsKnowAssemblyPoint-label">Did occupants know where to assemble? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="didOccupantsKnowAssemblyPoint-label"
                                                id="didOccupantsKnowAssemblyPoint-id"
                                                value={this.state.didOccupantsKnowAssemblyPoint }
                                                name="didOccupantsKnowAssemblyPoint"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="didOccupantsKnowAssemblyPointComments"
                                            name="didOccupantsKnowAssemblyPointComments"
                                            value={state.didOccupantsKnowAssemblyPointComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wasBuildingSearched-label">Were all areas of the building searched? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wasBuildingSearched-label"
                                                id="wasBuildingSearched-id"
                                                value={this.state.wasBuildingSearched }
                                                name="wasBuildingSearched"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wasBuildingSearchedComments"
                                            name="wasBuildingSearchedComments"
                                            value={state.wasBuildingSearchedComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="didAnyoneRefuseToLeave-label">Did anyone refuse to leave? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="didAnyoneRefuseToLeave-label"
                                                id="didAnyoneRefuseToLeave-id"
                                                value={this.state.didAnyoneRefuseToLeave }
                                                name="didAnyoneRefuseToLeave"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="didAnyoneRefuseToLeaveComments"
                                            name="didAnyoneRefuseToLeaveComments"
                                            value={state.didAnyoneRefuseToLeaveComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wereAllPeopleAccounted-label">Were all people accounted? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wereAllPeopleAccounted-label"
                                                id="wereAllPeopleAccounted-id"
                                                value={this.state.wereAllPeopleAccounted }
                                                name="wereAllPeopleAccounted"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wereAllPeopleAccountedComments"
                                            name="wereAllPeopleAccountedComments"
                                            value={state.wereAllPeopleAccountedComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="didAnyoneEnterBeforeClear-label">Did anyone enter the building before the all clear? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="didAnyoneEnterBeforeClear-label"
                                                id="didAnyoneEnterBeforeClear-id"
                                                value={this.state.didAnyoneEnterBeforeClear }
                                                name="didAnyoneEnterBeforeClear"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="didAnyoneEnterBeforeClearComments"
                                            name="didAnyoneEnterBeforeClearComments"
                                            value={state.didAnyoneEnterBeforeClearComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                            <InputLabel id="wereEmergencyServiceLiaised-label">Were emergency services liaised with? Yes / No / N/A</InputLabel>
                                            <Select
                                                labelId="wereEmergencyServiceLiaised-label"
                                                id="wereEmergencyServiceLiaised-id"
                                                value={this.state.wereEmergencyServiceLiaised }
                                                name="wereEmergencyServiceLiaised"
                                                onChange={this.handleTextChange}
                                            >
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                                <MenuItem value="NA">N/A</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="wereEmergencyServiceLiaisedComments"
                                            name="wereEmergencyServiceLiaisedComments"
                                            value={state.wereEmergencyServiceLiaisedComments}
                                            label="Comments"
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <p>DEBRIEF NOTES</p>
                                        <TextField
                                            id="notes"
                                            name="notes"
                                            value={state.notes}
                                            label="Outline any difficulties during the exercise / Suggested action"
                                            multiline
                                            rows={4}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onCancel}
                                            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                        >
                                            CANCEL
                                        </OrangeButton>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onSave}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            SAVE
                                        </GreenButton>
                                    </div>
                                </div>
                        )}
                    </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(EmergencyResponseTesting);
